import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TLHero from './components/TLHero';
import TLMarquee from './components/TLMarquee';
import TLProblem from './components/TLProblem';
import TLHow from './components/TLHow';
import TLStats from './components/TLStats';
import TLAudience from './components/TLAudience';
import TLExamples from './components/TLExamples';
import TLDialog from './components/TLDialog';
import TLCompare from './components/TLCompare';
import TLPricing from './components/TLPricing';
import TLROI from './components/TLROI';
import TLFAQ from './components/TLFAQ';

export default function TelegramLeads() {
  return (
    <main>
      <Navbar />
      <TLHero />
      <TLMarquee />
      <TLProblem />
      <TLHow />
      <TLStats />
      <TLAudience />
      <TLExamples />
      <TLDialog />
      <TLCompare />
      <TLPricing />
      <TLROI />
      <TLFAQ />
      <Footer />
    </main>
  );
}